import React, { useEffect, useState } from 'react'
import styles from './UserAvatar.module.scss'
import { Avatar, Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCrown } from '@fortawesome/pro-solid-svg-icons/faCrown'
import { faUserTag } from '@fortawesome/pro-solid-svg-icons/faUserTag'
import translations from '../../../../constants/translations'
import { getRandomColor } from 'helpers/color'

interface IAvatarUserProps {
  user: {
    name: string
    position: string
    avatar: string
    isAdmin?: boolean
    isModerator?: boolean
  }
  className?: string
}

const UserAvatar: React.FC<IAvatarUserProps> = ({ user: { name, position, avatar, isAdmin, isModerator }, className = '' }) => {
  const [color, setColor] = useState('')

  useEffect(() => {
    setColor(getRandomColor)
  }, [])

  return (
    <div className={`rankmiTable-avatar ${styles.container} ${className}`}>
      {avatar ? (
        <Avatar className="rankmiTable-avatar-image" src={avatar} />
      ) : (
        <Avatar className="rankmiTable-avatar-image" style={{ backgroundColor: color }}>
          {name[0] || ''}
        </Avatar>
      )}
      <div className={styles.rightSide}>
        <p className={`rankmiTable-avatar-username ${styles.userName}`}>
          {name}
          {(isAdmin || isModerator) && (
            <Tooltip placement="top" title={translations.columns[isAdmin ? 'isAdmin' : 'isModerator']}>
              <FontAwesomeIcon className={`ml-1 ${styles.adminIcon}`} icon={isAdmin ? faCrown : faUserTag} />
            </Tooltip>
          )}
        </p>
        {position && <small className={`rankmiTable-avatar-position ${styles.userPosition}`}>{position}</small>}
      </div>
    </div>
  )
}

export default UserAvatar
